module.exports = __webpack_public_path__ + "img/9788952755094.cd4d0380.jpg";